import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area all-products" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = {
  id: "C",
  border: "0",
  style: {"width":"100%","margin-bottom":"12px"}
}
const _hoisted_6 = { style: {"width":"100%","display":"flex","justify-content":"space-between","margin-bottom":"10px"} }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = { class: "text-body" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "ms-2 ps-1" }
const _hoisted_12 = { class: "fw-medium fs-14 mb-0" }
const _hoisted_13 = { class: "text-secondary" }
const _hoisted_14 = { class: "text-secondary" }
const _hoisted_15 = { class: "text-secondary" }
const _hoisted_16 = { class: "text-secondary" }
const _hoisted_17 = { class: "text-secondary" }
const _hoisted_18 = { class: "d-flex align-items-center gap-1" }
const _hoisted_19 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_20 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_21 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_22 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_23 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_24 = { class: "material-symbols-outlined fs-16 text-danger" }
const _hoisted_25 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap p-4" }
const _hoisted_26 = { class: "fs-12 fw-medium" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = { class: "fs-12 fw-medium me-2" }
const _hoisted_29 = { "aria-label": "Page navigation example" }
const _hoisted_30 = { class: "pagination mb-0 justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4\"><h3 class=\"mb-0\">User List</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>This Week</option><option value=\"1\">This Month</option><option value=\"2\">This Year</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_6, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemsPerPage) = $event)),
                    class: "form-select shadow-none",
                    style: {"float":"left","width":"99px !important","margin-right":"10px"}
                  }, [...(_cache[4] || (_cache[4] = [
                    _createStaticVNode("<option value=\"5\">5</option><option value=\"10\">10</option><option value=\"15\">15</option><option value=\"20\">20</option><option value=\"50\">50</option>", 5)
                  ]))], 512), [
                    [_vModelSelect, _ctx.itemsPerPage]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
                    class: "form-control shadow-none",
                    placeholder: "Search",
                    type: "text",
                    style: {"width":"145px","height":"40px"}
                  }, null, 512), [
                    [_vModelText, _ctx.searchTerm]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "User ID"),
                _createElementVNode("th", { scope: "col" }, "User"),
                _createElementVNode("th", { scope: "col" }, "Email"),
                _createElementVNode("th", { scope: "col" }, "Location"),
                _createElementVNode("th", { scope: "col" }, "Phone"),
                _createElementVNode("th", { scope: "col" }, "Projects"),
                _createElementVNode("th", { scope: "col" }, "Join Date"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.userID
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(item.userID), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("img", {
                        src: item.user.image,
                        class: "wh-40 rounded-3",
                        alt: "user"
                      }, null, 8, _hoisted_10),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h6", _hoisted_12, _toDisplayString(item.user.name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.email), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.location), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(item.phone), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(item.projects), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(item.joinDate), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("button", _hoisted_19, [
                        _createElementVNode("i", _hoisted_20, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_21, [
                        _createElementVNode("i", _hoisted_22, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_23, [
                        _createElementVNode("i", _hoisted_24, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("span", _hoisted_26, "Items per page: " + _toDisplayString(_ctx.itemsPerPage), 1),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.startIndex + 1) + " - " + _toDisplayString(_ctx.endIndex) + " of " + _toDisplayString(_ctx.filteredItems.length), 1),
            _createElementVNode("nav", _hoisted_29, [
              _createElementVNode("ul", _hoisted_30, [
                _createElementVNode("li", {
                  class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                }, [
                  _createElementVNode("a", {
                    class: "page-link icon",
                    href: "#",
                    "aria-label": "Previous",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                  ]))])
                ], 2),
                _createElementVNode("li", {
                  class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                }, [
                  _createElementVNode("a", {
                    class: "page-link icon",
                    href: "#",
                    "aria-label": "Next",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "material-symbols-outlined" }, " keyboard_arrow_right ", -1)
                  ]))])
                ], 2)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}